// extracted by mini-css-extract-plugin
export var section = "styles-module--section--oiJ_N";
export var list = "styles-module--list--2J_Fp";